import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { clientTypeToSuitableCatalogItemType } from '@common/utils/catalogType';
import { useClientProfile } from 'src/entities/client';

export const useCanInvite = (catalogItem?: CatalogItemViewModel) => {
  const clientProfile = useClientProfile();
  if (!clientProfile?.type) {
    return true;
  }
  if (!catalogItem) {
    return false;
  }
  return clientTypeToSuitableCatalogItemType(clientProfile.type) === catalogItem.type;
};
